import { IconProps } from '.';
const DownloadIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      className={customClasses}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3 19H21V21H3V19ZM13 13.1716L19.0711 7.1005L20.4853 8.51472L12 17L3.51472 8.51472L4.92893 7.1005L11 13.1716V2H13V13.1716Z"
        fill={color}
      />
    </svg>
  );
};

export default DownloadIcon;
